/* eslint-disable react/react-in-jsx-scope */
// eslint-disable-next-line no-unused-vars
import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import '@loyal/main.css'
import '@loyal_template/login.css'
import MediaQuery from 'react-responsive'

import Footer from './Footer/Footer'
import { ToggleFeature, features } from '../features/ToggleFeature'

const Layout = ({ children }) => {
  const handleFocus = (target) => {
    document.activeElement.blur()

    setTimeout(() => {
      let targetElement = document.querySelector(`${target}`)

      if (target === '#mainContainer') {
        targetElement = document.querySelector('h1')
      }

      if (targetElement) {
        targetElement.setAttribute('tabindex', '0')
        targetElement.focus()
        targetElement.addEventListener('blur', function () {
          targetElement.removeAttribute('tabindex')
        })
        targetElement.blur()
      }
    }, 300)
  }

  useEffect(() => {
    var htmlElement = document.querySelector('html')
    htmlElement.classList.add('clicking')

    document.addEventListener('click', function () {
      htmlElement.classList.add('clicking')
    })

    document.addEventListener('keyup', function (e) {
      if (e.keyCode === 9) {
        htmlElement.classList.remove('clicking')
      }
    })
  })
  return (
    <>
      {/* <MediaQuery minDeviceWidth={1025}>
        <div className='accessibility-menu'>
          <a
            href='#mainContainer'
            data-target='#mainContainer'
            className='flex-item mn-item mn-experiences'
            onClick={() => handleFocus('#mainContainer')}
          >
            Ir para o conteúdo principal
          </a>
          <a
            href='#footer'
            data-target='#footer'
            className='flex-item mn-item mn-experiences'
            onClick={() => handleFocus('#footer')}
          >
            Ir para o rodapé
          </a>
        </div>
      </MediaQuery> */}
      <div className={`container-login ${process.env.RAZZLE_HEADER_COMPONENT === undefined ? 'default-container-login' : ''} container-fluid px-0 py-0`}>
        <div className='login-wrapper bg-ui-4 mb-auto'>
          <MediaQuery minWidth={768}>
            <ToggleFeature feature={features.HeaderFeature} />
          </MediaQuery>
          <div className={`${process.env.RAZZLE_HEADER_COMPONENT !== undefined ? 'login-content pt-3' : ''} container-fluid px-0 px-md-1`} role='main'>
            <div className='container'>{children}</div>
          </div>
        </div>
        <MediaQuery minWidth={768}>
          <Footer />
        </MediaQuery>
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node
}

export default Layout
